import { render, staticRenderFns } from "./InjuryDonut.vue?vue&type=template&id=2b434a89&scoped=true"
import script from "./InjuryDonut.vue?vue&type=script&lang=js"
export * from "./InjuryDonut.vue?vue&type=script&lang=js"
import style0 from "./InjuryDonut.vue?vue&type=style&index=0&id=2b434a89&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b434a89",
  null
  
)

export default component.exports